import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Come funziona l'anamnesi iniziale dopo l'acquisto?",
    a: "Subito dopo l'ordine su WhatsApp ricevi il form completo di anamnesi corporea: raccolta misure, obiettivi, foto di partenza e preferenze alimentari per costruire il tuo programma su misura.",
  },
  {
    q: "Posso allenarmi sia a casa che in palestra?",
    a: "Certamente. La scheda viene formulata esattamente sull'attrezzatura a tua disposizione, massimizzando il rendimento con qualsiasi setup.",
  },
  {
    q: "Il file Excel interattivo è compreso in tutti i pacchetti?",
    a: "Sì: il file Excel per il calcolo del fabbisogno giornaliero e la sostituzione dei pasti in autonomia è incluso in ognuno dei 4 pacchetti e te lo invio direttamente su WhatsApp dopo l'acquisto.",
  },
  {
    q: "Ogni quanto viene rinnovata la scheda?",
    a: "Nei pacchetti Trimestrale, Semestrale e Annuale la scheda viene rinnovata gratuitamente ogni 45 giorni: rivaluto carichi, volume e risposte del tuo corpo e ti consegno una nuova scheda aggiornata, per non permettere al corpo di stallare.",
  },
  {
    q: "Come si acquista un pacchetto?",
    a: "Semplice: scegli il pacchetto, premi il pulsante WhatsApp e mi scrivi. Concordiamo insieme il pagamento e partiamo subito con l'anamnesi. Puoi usare WhatsApp anche solo per fare domande prima di iniziare.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 px-5 sm:px-8 border-t border-white/10">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7 }}
          className="mb-12"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-blood font-semibold mb-4">// FAQ</p>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl leading-[0.95]">
            Domande <span className="text-blood">frequenti</span>
          </h2>
        </motion.div>

        <div>
          {faqs.map((f, i) => (
            <motion.div
              key={f.q}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="border-b border-white/10"
            >
              <button
                data-testid={`faq-toggle-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 py-5 text-left group"
              >
                <span className={`font-display font-bold uppercase text-lg sm:text-xl tracking-tight transition-colors ${open === i ? "text-blood" : "text-white group-hover:text-blood"}`}>
                  {f.q}
                </span>
                <ChevronDown size={20} className={`shrink-0 text-blood transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 text-neutral-300 text-sm sm:text-base leading-relaxed">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
